/**
 * Route shell only. The screen itself is @alight/enrolment-ui, shared with the
 * other app — see docs/HTBH-MIGRATION.md §8a.
 */
import { createFileRoute } from "@tanstack/react-router";
import { AdminInvoices } from "@alight/enrolment-ui";

export const Route = createFileRoute("/admin/invoices")({
  component: AdminInvoices,
});
